import React, {
  EventHandler, memo, MouseEvent, useCallback, useEffect, useMemo,
} from 'react';

import { getContrastColor } from 'app/lib/Color';
import { ReactComponent as IconClose } from 'assets/image/btn-close.svg';
import { useDispatcher } from 'app/store/utils/redux/hooks';

import styles from './Promo.module.css';

interface IPromo {
  handleSkipPromo?: EventHandler<MouseEvent>,
  bannerContainerRef?: React.MutableRefObject<null>,
  title: string,
  color: string,
  url: string,
  text: string,
  image?: string,
  hasButton: boolean,
}

const Promo: React.FC<IPromo> = memo((props) => {
  const {
    handleSkipPromo,
    bannerContainerRef,
    title,
    color,
    url,
    text,
    image,
    hasButton,
  } = props;

  const actions = useDispatcher();

  useEffect(() => {
    actions.promo.sendViewed();
  }, [actions.promo]);

  const handleLinkOpen = useCallback(() => {
    actions.promo.sendTapped();
  }, [actions.promo]);

  const contrastColor = getContrastColor(color, true, '#555');

  const renderBody = useMemo(() => (
    <>
      {bannerContainerRef && (
        <div className={styles.cover} ref={bannerContainerRef} />
      )}
      {!bannerContainerRef && image && (
        <img src={image} className={styles.cover} alt="promo" />
      )}
      <div className={styles.wrapper}>
        <div className={styles.title} style={{ color }}>{title || ''}</div>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        {hasButton && (
          <a
            className={styles.link}
            style={{ backgroundColor: color, color: contrastColor }}
            href={url}
            onClick={handleLinkOpen}
            target="_blank"
            rel="noreferrer"
          >
            {text}
          </a>
        )}
      </div>
    </>
  ), [bannerContainerRef, color, contrastColor, handleLinkOpen, hasButton, image, text, title, url]);

  return (
    <div className={styles.steps}>
      {hasButton && (
        <div className={styles.promo}>
          {renderBody}
        </div>
      )}
      {!hasButton && (
        <a className={styles.promo} href={url} onClick={handleLinkOpen} target="_blank" rel="noreferrer">
          {renderBody}
        </a>
      )}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      {handleSkipPromo && (
        <button className={styles.close} onClick={handleSkipPromo} type="button">
          <IconClose />
        </button>
      )}
    </div>
  );
});

export default Promo;
